import { Button } from "@gigpro/ui/Button";
import { DialogFooter } from "@gigpro/ui/Dialog";

interface PostFreeChoiceCardProps {
  /** What the plan costs and whether it starts with a trial. */
  planLine: string;
  /** The second option's label; absent for a team member, who gets `adminNote` instead. */
  planActionLabel?: string;
  /** Shown in place of the second button when only an admin can start the plan. */
  adminNote?: string;
  onPost: () => void;
  onStartPlan?: () => void;
  onBack: () => void;
}

/**
 * Step 2 of the new-job flow for a location without a plan: posting is free, working interviews come with the Jobs
 * plan. Posting is the primary action so the plan never reads as the price of the job.
 */
export const PostFreeChoiceCard = ({
  planLine,
  planActionLabel,
  adminNote,
  onPost,
  onStartPlan,
  onBack,
}: PostFreeChoiceCardProps) => (
  <div className="flex flex-col gap-4">
    <p className="text-large font-semibold">Your job is ready to post, free.</p>
    <div className="flex flex-col gap-1">
      <p className="text-normal font-semibold">Want working interviews too?</p>
      <p className="text-small text-gray">Candidates work a paid shift with you before you hire.</p>
      <p className="text-small text-gray">{planLine}</p>
    </div>
    <div className="flex flex-col gap-2">
      <Button variant="contained" onClick={onPost}>
        Post job
      </Button>
      {adminNote ? (
        <p className="text-center text-small text-gray">{adminNote}</p>
      ) : (
        <Button variant="outlined" onClick={onStartPlan}>
          {planActionLabel}
        </Button>
      )}
    </div>
    <DialogFooter>
      <Button variant="text" onClick={onBack}>
        Back
      </Button>
    </DialogFooter>
  </div>
);
